/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";

export const IconArrowBack = ({ color = "white", className }) => {
  return (
    <svg
      className={`icon-arrow-back ${className}`}
      fill="none"
      height="19"
      viewBox="0 0 19 19"
      width="19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        clipRule="evenodd"
        d="M15.8333 8.70833H6.19875L10.6242 4.28292L9.5 3.16667L3.16667 9.5L9.5 15.8333L10.6163 14.7171L6.19875 10.2917H15.8333V8.70833Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
};

IconArrowBack.propTypes = {
  color: PropTypes.string,
};
